// src/components/Common/FloatingSearchButton.js
import React, { useEffect, useState } from 'react';
import './FloatingSearchButton.css';

const FloatingSearchButton = ({ onClick }) => {
  const [buttonBottom, setButtonBottom] = useState(30); // Default bottom position

  useEffect(() => {
    const handleScroll = () => {
      // Find the footer element
      const footer = document.querySelector('.app-footer');
      if (!footer) return;

      // Get positions
      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Check if mobile (viewport width <= 768px)
      const isMobile = window.innerWidth <= 768;
      
      // Adjust values based on device type
      const buttonHeight = isMobile ? 50 : 60; // Smaller button height estimate for mobile
      const minGap = isMobile ? 10 : 20; // Smaller gap on mobile
      const defaultBottom = isMobile ? 10 : 30; // Much lower default position on mobile
      
      // If footer is visible in the viewport
      if (footerRect.top < windowHeight) {
        // Calculate how much the button needs to move up
        const overlap = windowHeight - footerRect.top + buttonHeight + minGap;
        if (overlap > 0) {
          setButtonBottom(defaultBottom + overlap);
        } else {
          setButtonBottom(defaultBottom);
        }
      } else {
        // Footer is not visible, use default position
        setButtonBottom(defaultBottom);
      }
    };

    // Add scroll and resize listeners
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll); // Also listen for resize events
    
    // Check initial position
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <button 
      type="button" 
      className="floating-search-button" 
      onClick={onClick}
      style={{ bottom: `${buttonBottom}px` }}
    >
      Search Supplements
    </button>
  );
};

export default FloatingSearchButton;
